import { SurveyAnswer } from "./SurveyAnswer";

export class SurveyEnumAnswer extends SurveyAnswer {
    public constructor(
        public valueEnum: string
    ) {
        super();
    }
 }
